
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.555 2.666h2.993l.965 2.412-1.55 1.034a.667.667 0 00-.297.554c.002.063 0 .001 0 .001v.014a1.3 1.3 0 00.005.09c.003.054.01.128.023.219.026.18.076.428.173.72.196.587.58 1.346 1.328 2.094.748.748 1.507 1.133 2.094 1.328.292.098.54.148.72.174a2.926 2.926 0 00.31.027h.013s.075-.004.001 0a.667.667 0 00.596-.369l.447-.892 2.957.492v2.88c-1.407.204-5.208.404-8.195-2.582C2.15 7.875 2.352 4.074 2.555 2.666zM6.05 6.99l1.204-.802c.524-.35.732-1.02.498-1.605l-.965-2.412a1.333 1.333 0 00-1.238-.838H2.52c-.605 0-1.175.42-1.275 1.078-.226 1.495-.534 5.91 2.95 9.393 3.484 3.485 7.899 3.177 9.393 2.95.658-.1 1.079-.67 1.079-1.275v-2.915c0-.651-.472-1.208-1.115-1.315l-2.957-.493a1.333 1.333 0 00-1.412.72l-.23.461a3.108 3.108 0 01-.242-.07c-.414-.138-.988-.42-1.573-1.005-.585-.586-.868-1.16-1.006-1.573a3.057 3.057 0 01-.083-.299z","fill":"#A0AEC0"}})])
          )
        }
      }
    